// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import { useAutoCompleteTeamUserField } from './hooks';

import { fontWeight, spacing } from 'presentations/views/styles';

import Avatar from 'presentations/views/components/atoms/Avatar';
import { ViewerItem } from 'presentations/api/schema/user';
import AutoCompleteTextField from '../../atoms/AutoCompleteTextField';
import MenuItem from '../../atoms/MenuItem';

interface Props {
  name: string;
  size?: 'small' | 'medium';
  viewer: ViewerItem;
  isExcludeViewer: boolean;
  selectedTeamUserIds: string[];
  isDisabled: boolean;
  isSupportString?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  onUpdate?: any;
  placeholder?: string;
  value?: any;
  isFreeSolo?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const { state, actions } = useAutoCompleteTeamUserField(props);

  return (
    <AutoCompleteTextField
      filterOptions={(x: any) => x}
      name={props.name}
      options={state.teamUserOptions}
      isDisabled={props.isDisabled}
      inputValue={state.inputValue}
      value={props.value}
      size={props.size || 'medium'}
      placeholder={props.placeholder ?? t('Placeholder')}
      isFullWidth={true}
      variant={props.variant}
      isFreeSolo={props.isFreeSolo}
      onChange={actions.onChangeAutoComplete}
      renderOption={(props, option) => (
        <MenuItem {...props} key={`${props.id}_${option.title}`}>
          {option.image && <OptionUserAvatar src={option.image} />}
          <StyledAutoCompleteOptionName>
            {option.title}
          </StyledAutoCompleteOptionName>
        </MenuItem>
      )}
      onInputChange={actions.onInputChange}
    />
  );
}

const OptionUserAvatar = styled(Avatar)<{
  color?: string | null;
}>`
  width: 32px;
  height: 32px;
  margin-right: ${spacing(8)};
  background-color: ${(props) => props.color};
  font-weight: ${fontWeight('bold')};
`;
const StyledAutoCompleteOptionName = styled.span`
  display: inline-block;
  margin-left: ${spacing(8)};
`;
